import {useEffect, useRef, useState} from 'react';

const Ad2 = ({index = 0}) => {
    const adRef = useRef(null);
    const [isAdFilled, setIsAdFilled] = useState(true);

    useEffect(() => {
        try {
            if (typeof window !== 'undefined') {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (e) {
            console.error('Adsense error:', e);
        }
    }, []);

    useEffect(() => {
        const el = adRef.current;
        if (!el) return;

        const checkAdStatus = () => {
            const status = el.getAttribute('data-ad-status');
            if (status === 'unfilled') {
                setIsAdFilled(false);
            }
        };

        const observer = new MutationObserver(() => {
            checkAdStatus();
        });

        observer.observe(el, {attributes: true});

        // Fallback: check after 2 seconds
        const timeout = setTimeout(() => {
            checkAdStatus();
        }, 3000);

        return () => {
            observer.disconnect();
            clearTimeout(timeout);
        };
    }, []);

    if (process.env.REACT_APP_SHOW_ADS_ON_PLATFORM !== "true") {
        return null;
    }

    return <>
        {isAdFilled && (

            <div className="p-4 mx-1 md:ml-0 pb-0 bg-gray-800 rounded-lg mt-4 max-w-full">
                <div className="max-w-[300px] mx-auto">
                    <ins
                        className="adsbygoogle"
                        style={{display: 'block', width: '100%', height: '250px'}}
                        data-ad-client="ca-pub-6173665925818507"
                        data-ad-slot={"8988593339"}
                        data-ad-channel={process.env.REACT_APP_ADS_CHANNEL_ID}
                        ref={adRef}
                    ></ins>
                    <div className="text-center text-xs text-gray-100 py-2 mt-2">Advertisement</div>
                </div>
            </div>)}
    </>
};

export default Ad2;
